import React, { useMemo } from 'react';

export const useFormattedTemplate = (
  messageTemplate: string,
  additionalProps?: Record<string, any>
) =>
  useMemo(() => {
    return applyBoldTagToTemplate(messageTemplate, additionalProps);
  }, [messageTemplate, additionalProps]);

const applyBoldTagToTemplate = (
  messageTemplate: string,
  additionalProps?: Record<string, any>
) => {
  const boldTagRegex = /<b>|<\/b>/;
  const splittedByBoldTag = messageTemplate.split(boldTagRegex);

  return splittedByBoldTag.filter(Boolean).map((value, idx) => {
    return idx % 2 === 0 ? (
      value
    ) : (
      <b key={idx} {...additionalProps}>
        {value}
      </b>
    );
  });
};
